export default __webpack_public_path__ + "static/media/Roboto-Bold.5f2071a3.eot";